import { request } from './api';

/** 获取赛事赛程安排（operator batches） */
export const getRaceOperatorBatches = (rid: string | number): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-batches`,
    }).then(res => res);
};

/** 获取赛道数据概览（operator overview） */
export const getRaceOperatorOverview = (rid: string | number): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-overview`,
    }).then(res => res);
};

/** 获取我的参赛信息（operator my participation） */
export const getOperatorMyParticipation = (rid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-my-participation`,
        params,
    }).then(res => res);
};

/** 获取赛题列表（operator tasks） */
export const getOperatorTasks = (rid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-tasks`,
        params,
    }).then(res => res);
};

/** 获取提交配额（operator submissions quota） */
export const getOperatorSubmissionQuota = (rid: string | number): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-submissions/quota`,
    }).then(res => res);
};

/** 提交作品（operator submissions） */
export const submitOperatorArchive = (rid: string | number, formData: FormData): Promise<any> => {
    return request({
        method: 'post',
        url: `/races/${rid}/operator-submissions`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Idempotency-Key': `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`,
        },
    }).then(res => res);
};

/** 获取提交记录列表（operator submissions） */
export const getOperatorSubmissions = (rid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-submissions`,
        params,
    }).then(res => res);
};

/** 获取实时排行榜（operator leaderboards realtime） */
export const getOperatorRealtimeLeaderboard = (rid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-leaderboards/realtime`,
        params,
    }).then(res => res);
};

/** 获取最终排行榜（operator leaderboards final） */
export const getOperatorFinalLeaderboard = (rid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-leaderboards/final`,
        params,
    }).then(res => res);
};

/** 获取赛题题目说明（operator task detail） */
export const getOperatorTaskStatement = (rid: string | number, operator: string): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-tasks/${operator}`,
    }).then(res => res);
};

/** 获取单题排行榜 */
export const getOperatorSingleTaskLeaderboard = (rid: string | number, tid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-tasks/${tid}/leaderboard`,
        params,
    }).then(res => res);
};

/** 获取单题荣誉结果 */
export const getOperatorHonorResult = (rid: string | number, tid: string | number, params?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-tasks/${tid}/honor-result`,
        params,
    }).then(res => res);
};

/** 获取 PR 提交信息（operator occupation pr） */
export const getOperatorOccupationPr = (rid: string | number, tid: string | number): Promise<any> => {
    return request({
        method: 'get',
        url: `/races/${rid}/operator-tasks/${tid}/occupation-pr`,
    }).then(res => res);
};

/** 提交 PR 链接（operator occupation pr） */
export const submitOperatorOccupationPr = (rid: string | number, tid: string | number, githubPr: string, claSigned?: boolean): Promise<any> => {
    return request({
        method: 'put',
        url: `/races/${rid}/operator-tasks/${tid}/occupation-pr`,
        data: { github_pr: githubPr, cla_signed: !!claSigned },
    }).then(res => res);
};

/** 获取 AMD 开发者社区 OAuth 授权跳转地址（服务端拼接授权 URL，前端拿到后直接跳转） */
export const getAmdOauthLoginUrl = (rid: string | number, redirectUri: string): Promise<any> => {
    return request(
        {
            method: 'get',
            url: '/oauth/amd/login-url',
            params: { rid, redirect_uri: redirectUri },
        },
        false
    ).then(res => res);
};

/** 将 AMD OAuth 授权 code/state 交由服务端回调处理（换票/绑定，服务端处理完成） */
export const getAmdOauthCallback = (code: string, state: string): Promise<any> => {
    return request({
        method: 'get',
        url: '/oauth/amd/callback',
        params: { code, state },
    }).then(res => res);
};
